module.exports = __webpack_public_path__ + "media/zuopin5.e506a3ea.mp4";